import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import { Form } from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from 'src/app/core/services/customer.service';
import { IClientModel } from 'src/app/core/models/application.model';
import { IUser } from 'src/app/core/models/user.model';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css'],
})
export class AddUserComponent implements OnInit {
  @Input() application: IClientModel;
  @Input() applicationId: string;
  @Input() applications: IClientModel[];
  @Input() customers: any;
  @Output() formBody = new EventEmitter<Object>();
  @ViewChild('dialogAddUser') public dialogAddUser: TemplateRef<any>;
  toggleNewClient: boolean = false;
  currentUser: IUser;
  showCustomers: boolean = false;
  searchCustomersParam: string = '';
  customersSearch: IClientModel[] = [];
  selectedCustomer = null;

  showClients: boolean = false;
  searchClientsParam: string = '';
  clientsSearch: IClientModel[] = [];
  selectedClient: IClientModel = null;
  private modalAddUser: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    public router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private customerService: CustomerService
  ) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });
    console.log(this.customers);
    console.log(this.application);
    this.customersSearch = this.customers;
  }

  open(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.modalAddUser = this.modalService.open(this.dialogAddUser);
      this.modalAddUser.result.then(resolve, resolve);
    });
  }

  async close(): Promise<void> {
    this.modalAddUser.close();
  }

  openCustomers() {
    this.showCustomers = !this.showCustomers;
    this.searchCustomersParam = '';
    this.customersSearch = this.customers;
    this.showClients = false;
  }

  applyCustomerFilter() {
    this.customersSearch = [];
    this.customersSearch = this.customers.filter(
      (customer) =>
        customer.name
          .toLowerCase()
          .indexOf(this.searchCustomersParam.toLowerCase()) !== -1
    );
  }

  selectCustomer(customer) {
    this.selectedCustomer = customer;
    this.customerService
      .getApplications(customer.id)
      .subscribe((res: IClientModel[]) => {
        this.applications = res;
      });
  }

  openClients() {
    this.showClients = !this.showClients;
    this.searchClientsParam = '';
    this.clientsSearch = this.applications;
    this.showCustomers = false;
  }

  applyClientFilter() {
    this.clientsSearch = [];
    this.clientsSearch = this.applications.filter(
      (client) =>
        client.name
          .toLowerCase()
          .indexOf(this.searchClientsParam.toLowerCase()) !== -1
    );
  }

  selectClient(client) {
    this.selectedClient = client;
  }

  sendUser(form, toggleNewClient) {
    let customerId: string;
    let clientId: string;

    if (form.form.value.fullName == '') {
      this.translate.get('errors.youMustEnterName').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return false;
    }
    if (form.form.value.email == '') {
      this.translate
        .get('customer.enterEmailError')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return false;
    }
    if (form.form.value.password == '') {
      this.translate
        .get('customer.enterPasswordError')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return false;
    }
    if (form.form.value.password != form.form.value.passwordRepeat) {
      this.translate
        .get('customer.samePasswordError')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return false;
    }
    if (form.form.value.password != form.form.value.passwordRepeat) {
      this.translate
        .get('customer.samePasswordError')
        .subscribe((text: string) => {
          this.toastr.error(text);
        });
      return false;
    }
    if (form.form.value.type == '') {
      this.translate.get('errors.selectUserType').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return false;
    }

    if (this.customers) {
      if (this.selectedCustomer === null) {
        this.translate.get('errors.selectCustomerFirst').subscribe((text: string) => {
          this.toastr.error(text);
        });
        return false;
      } else {
        customerId = this.selectedCustomer.id;
      }
    }
    if (!form.valid) {
      return this.translate.get('errors.pleaseFillRequiredFields').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    if (toggleNewClient) {
      if (
        form.form.value.nameClient === '' ||
        form.form.value.description === ''
      ) {
        this.translate.get('errors.pleaseFillRequiredFields').subscribe((text: string) => {
        this.toastr.error(text);
      });
        return false;
      }
    } else {
      if (['root', 'customer'].includes(this.currentUser.role.name)) {
        if (this.selectedClient === null && !this.router.url.includes('/root/applications')) {
          this.translate.get('errors.selectClient').subscribe((text: string) => {
            this.toastr.error(text);
          });
          return false;
        } else {
          clientId = this.selectedClient?.id || this.applicationId;
        }
      }
    }

    this.formBody.emit({ form, toggleNewClient, clientId, customerId });
  }
}
